import { Component, computed, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TsButtonModule } from 'tsui';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TaskStatusService } from '@tasks/services/task-status.service';
import { TaskStatus } from '@tasks/tasks.types';

@Component({
  standalone: true,
  imports: [
    MatIconModule,
    NgClass,
    RouterModule,
    TsButtonModule,
    NgClass,
    MatProgressBarModule,
    MatTooltipModule,
    TsButtonModule,
  ],
  selector: 'table-task-status-renderer',
  template: `
    <span class="inline-flex items-center rounded-full tracking-wide capitalize">
      <span
        class="w-2 h-2 rounded-full"
        [class.mr-2]="true"
        [ngClass]="{
          'bg-yellow': status() === 'quoted',
          'bg-gray-500': status() === 'n_a' || status() === 'sent',
          'bg-gray-700': status() === 'not_started',
          blue: status() === 'in_progress' || status() === 'received',
          'yellow-300': status() === 'in_approval',
          red: status() === 'needs_review' || status() === 'rejected',
          green: status() === 'complete' || status() === 'accepted' || status() === 'competitive',
        }"
      ></span>
      <span class="pr-2px leading-relaxed whitespace-nowrap">{{ taskStatus() }}</span>
    </span>
  `,
  styles: [
    `
      .section-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        padding-top: 4px;
      }

      .section-progress {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 277px;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
      }
      .tasks-container {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 4px;
      }
      .task-title {
        text-decoration: none;
        color: inherit;
      }
      .task-title-child {
        margin-left: 20px;
      }
      .task-title-deep-child {
        margin-left: 50px;
      }
      .expand-icon {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 16px;
      }
    `,
  ],
})
export class TableTasksStatusRendererComponent implements ICellRendererAngularComp {
  status = signal<string>('');
  workflowStates;
  taskStatusService = inject(TaskStatusService);

  agInit(params: ICellRendererParams): void {
    this.workflowStates = this.taskStatusService.getAvailableWorkflowStates();
    this.status.set(params.data.workflow_state);
  }

  refresh(params: ICellRendererParams): boolean {
    this.status.set(params.data.workflow_state);
    return true;
  }

  taskStatus = computed(() => {
    const status = this.status();
    if (!status) {
      return;
    }
    return this.workflowStates.find((taskStatus) => taskStatus.key === status)?.label;
  });
}
